// extracted by css-extract-rspack-plugin
export default {"success":"Security_success__J-7yE"};